import { Card, CardContent } from "../../components/ui/card";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearRolesAccess } from "../RoleManagement/RoleManagementSlice";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "../../components/ui/table";
import { message } from "antd";
import {
  getRoleAccessRecordsApi,
  updateRoleAccessRecordsApi,
} from "../RoleManagement/RoleManagementApi";
import { Button } from "../../components/ui/button";
import { Save } from "lucide-react";

function RoleManagement() {
  const dispatch = useDispatch();
  const roleAccessRecords = useSelector(
    (state) => state.RoleManagement.roleAccessRecords
  );

  const [records, setRecords] = useState([]);
  const [isCheckChanged, setIsCheckChanged] = useState(false);
  const [changedRoleIds, setChangedRoleIds] = useState(new Set());
  useEffect(() => {
    dispatch(clearRolesAccess());
    dispatch(getRoleAccessRecordsApi());
  }, []);

  useEffect(() => {
    if (roleAccessRecords?.length) {
      const cloned = structuredClone
        ? structuredClone(roleAccessRecords)
        : JSON.parse(JSON.stringify(roleAccessRecords));
      setRecords(cloned);
    }
  }, [roleAccessRecords]);

  const roles = records?.map((r) => r.roleName) || [];

  const pages =
    records?.[0]?.roleAccessDetails?.[0]?.accesses?.map((a) => a.accessName) ||
    [];

  function toggleCheckbox(roleIndex, pageIndex) {
    const updated = structuredClone
      ? structuredClone(records)
      : JSON.parse(JSON.stringify(records));

    const roleId = updated[roleIndex].roleId;

    updated[roleIndex].roleAccessDetails[0].accesses[pageIndex].hasAccess =
      !updated[roleIndex].roleAccessDetails[0].accesses[pageIndex].hasAccess;

    setRecords(updated);
    setIsCheckChanged(true);

    // mark roleId as changed
    setChangedRoleIds((prev) => new Set(prev).add(roleId));
  }

  function handleUpdate() {
    if (!records?.length) return;

    const updates = [];

    records.forEach((role) => {
      role.roleAccessDetails.forEach((detail) => {
        detail.accesses.forEach((a) => {
          if (a.hasAccess) {
            updates.push({
              roleId: role.roleId,
              accessId: a.accessId,
            });
          }
        });
      });
    });

    const payload = { updates };

    dispatch(
      updateRoleAccessRecordsApi(payload, (success) => {
        if (success) {
          setIsCheckChanged(false);

          const loggedInRoleId = localStorage.getItem("roleId");

          if (
            changedRoleIds.has(Number(loggedInRoleId)) ||
            changedRoleIds.has(1) // super admin
          ) {
            message.warning(
              "Your permissions have been updated. Please logout and login again to see the changes."
            );
          }

          setChangedRoleIds(new Set());
        }
      })
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Role Management</h1>
          <p className="text-gray-600">
            Define and manage roles & permissions dynamically from backend
          </p>
        </div>
      </div>

      <Card>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Page/Action</TableHead>
                {roles.map((role) => (
                  <TableHead key={role}>{role}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {pages.map((page, pageIdx) => (
                <TableRow key={page}>
                  <TableCell>{page}</TableCell>
                  {records.map((role, roleIdx) => (
                    <TableCell key={`${role.roleName}-${page}`}>
                      <input
                        type="checkbox"
                        checked={
                          role.roleAccessDetails?.[0]?.accesses?.[pageIdx]
                            ?.hasAccess || false
                        }
                        onChange={() => toggleCheckbox(roleIdx, pageIdx)}
                        className="accent-blue-600 h-5 w-5"
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <div className="flex justify-end gap-4">
        <Button type="submit" disabled={!isCheckChanged} onClick={handleUpdate}>
          <Save className="h-4 w-4 mr-2" />
          Update
        </Button>
      </div>
    </div>
  );
}

export default RoleManagement;
